import O1HD from "../../../../engines/gameEngine";

const {ccclass, property} = cc._decorator;
/**
 * 快递传输带节点
 */
@ccclass
export default class ExpressSsdNode extends cc.Component {

    @property({type:cc.Node,displayName:"快递节点"})
    expressItemNode : cc.Node = null;

    onLoad () {
        O1HD.on("ExpressSsdNode.addExpressNode" , this.addExpressNode , this );
        O1HD.on("ExpressSsdNode.clearExpressNode", this.clearExpressNode , this );
    }

    start () {

    }

    /**
     * 添加一个快递节点
     */
    addExpressNode (  ){
        if ( this.node ) {
            let addNode = cc.instantiate( this.expressItemNode );
            addNode.active = true;
            this.node.addChild( addNode );
        }
    }

    /**
     * 清除节点
     */
    clearExpressNode(){
        if ( this.node ) {
            this.node.removeAllChildren();
        }
    }


}
